import React, { useState, useEffect, useRef } from "react";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import AdminCustomButton from "../../../../components/CommonComponents/AdminCustomButton";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import { IconDeleteFigma, IconDeleteSolid, IconEditFigma, IconSolidEdit } from "../../../../Assets/MyIcons";
import { toast } from "react-toastify";
import { IoMdInformationCircle } from "react-icons/io";
import AdminDeleteModal from "../../../../components/CommonComponents/AdminDeleteModal";
import NoRecordTable from "../../../../components/CommonComponents/NoRecordTable";
import BootstrapTable from "react-bootstrap-table-next";
import { getItem, getItemToken } from "../../../../Utils/localStorageUtils";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight, } from "react-icons/md";
import { donwloadCSV, downloadPDF, downloadXLSX, findUploadName } from "../../../../components/CommonMethod/CommonMethods";
import { IoClose } from 'react-icons/io5';
import Defaultloadinggif from "../../../../layout/Others/Defaultloadinggif";
import MessageBox from "../../../../components/CommonComponents/MessageBox";
import AdminCustomSelect from "../../../../components/CommonComponents/AdminCustomSelect";

function Rtmpurl() {
    const { fetchRequest } = useMyContext()
    const [modelOpen, setModelOpen] = useState(false)
    const [formData, setFormData] = useState()
    const [apiData, setApiData] = useState()
    const [labelDisplay, setLabelDisplay] = useState([]);
    const [formDataError, setFormDataError] = useState({})
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [showOverlay, setShowOverlay] = useState(false);
    const [loading, setLoading] = useState(true)
    const [itemToDelete, setItemToDelete] = useState([]);
    const [modelClose, setModelClose] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [filter, setFilter] = useState('');
    const [editBaseUrl, setEditBaseUrl] = useState(false);
    const combinedRef = useRef({});


    const baseURL = process.env.REACT_APP_Baseurl

    const labelApi = `${baseURL}/admin/Label-Management/list-source`
    const editApi = `${baseURL}/admin/setting/rmtp`
    const storeApi = `${baseURL}/admin/setting/rmtp/store`
    const deleteUpdateApi = `${baseURL}/admin/setting/rmtp`
    const indexApi = `${baseURL}/admin/setting/rmtp/index`

    const PLATFORM_OPTIONS = [
        { value: 'custom', name: 'Custom' },
        { value: 'youtube', name: 'YouTube' },
        { value: 'facebook', name: 'Facebook' },
        { value: 'instagram', name: 'Instagram' },
        { value: 'linkedin', name: 'LinkedIn' },
        { value: 'twitch', name: 'Twitch' },
    ]

    const PLATFORM_RTMP_URLS = {
        youtube: 'rtmp://a.rtmp.youtube.com/live2/',
        facebook: 'rtmps://live-api-s.facebook.com:443/rtmp/',
        instagram: 'rtmps://live-upload.instagram.com:443/rtmp/',
        linkedin: 'rtmp://live.linkedin.com:1935/rtmp/',
        twitch: 'rtmp://live.twitch.tv/app/',
    }

    const PLATFORM_WATCH_URLS = {
        youtube: 'https://www.youtube.com/watch?v=',
        facebook: 'https://www.facebook.com/live/',
        instagram: 'https://www.instagram.com/',
        linkedin: 'https://www.linkedin.com/video/live/',
        twitch: 'https://www.twitch.tv/',
    }

    const PLATFORM_HELP_INFO = {
        youtube: {
            steps: '1. Go to YouTube Studio → Go Live  2. Copy the "Stream Key" from the stream settings',
            helpUrl: 'https://studio.youtube.com/channel/UC/livestreaming',
            helpLabel: 'Open YouTube Studio',
        },
        facebook: {
            steps: '1. Go to Facebook → Live Producer  2. Copy the "Stream Key" from the stream setup',
            helpUrl: 'https://www.facebook.com/live/producer',
            helpLabel: 'Open Facebook Live Producer',
        },
        instagram: {
            steps: '1. Open Instagram App → Go Live  2. Copy the "Stream Key" from the live settings (Professional accounts only)',
            helpUrl: 'https://help.instagram.com/',
            helpLabel: 'Instagram Help Center',
        },
        linkedin: {
            steps: '1. Go to LinkedIn → Start a post → Go Live  2. Copy the "Stream Key" from the broadcast setup',
            helpUrl: 'https://www.linkedin.com/video/golive/',
            helpLabel: 'Open LinkedIn Live',
        },
        twitch: {
            steps: '1. Go to Twitch Dashboard → Settings → Stream  2. Copy the "Primary Stream Key"',
            helpUrl: 'https://dashboard.twitch.tv/settings/stream',
            helpLabel: 'Open Twitch Dashboard',
        },
    }

    const isCustomPlatform = !formData?.platform || formData?.platform === 'custom';
    const selectedPlatformUrl = PLATFORM_RTMP_URLS[formData?.platform] || '';
    const currentHelp = PLATFORM_HELP_INFO[formData?.platform] || null;
    const isValidRtmpUrl = (url) => {
        const regex = /^rtmp:\/\/([a-z0-9\-]+\.)+[a-z0-9\-]+(:[0-9]+)?(\/[a-z0-9\-._~%!$&'()*+,;=:@]+)*$/i;
        return regex.test(url) && url.length <= 512;
    };

    const YOUTUBE_RTMP_REGEX = /^rtmps?:\/\/a\.rtmp\.youtube\.com\/live2\/[A-Za-z0-9_-]{5,}$/;
    const FACEBOOK_RTMP_REGEX = /^rtmps?:\/\/live-api-s\.facebook\.com(:443)?\/rtmp\/[A-Za-z0-9_-]{5,}$/;
    const INSTAGRAM_RTMP_REGEX = /^rtmps?:\/\/edgetee-upload-maa5-2\.xx\.fbcdn\.net(:443)?\/rtmp\/[A-Za-z0-9_-]{10,}$/;
    const LINKEDIN_RTMP_REGEX = /^rtmps?:\/\/live\.linkedin\.com(:1935)?\/rtmp\/[A-Za-z0-9_-]{5,}$/;

    function isValidSocialMediaRtmpUrl(url) {
        if (YOUTUBE_RTMP_REGEX.test(url)) return true;
        if (FACEBOOK_RTMP_REGEX.test(url)) return true;
        if (INSTAGRAM_RTMP_REGEX.test(url)) return true;
        if (LINKEDIN_RTMP_REGEX.test(url)) return true;
        return false;
    }

    function getSocialMediaError(url) {
        if (YOUTUBE_RTMP_REGEX.test(url))
            return "";

        if (FACEBOOK_RTMP_REGEX.test(url))
            return "";

        if (INSTAGRAM_RTMP_REGEX.test(url))
            return "";

        if (LINKEDIN_RTMP_REGEX.test(url))
            return "";

        return "Invalid social media RTMP URL. Supported formats: YouTube, Facebook, Instagram, LinkedIn.";
    }


    const isValidHlsUrl = (url) => {
        const regex = /^https:\/\/([a-z0-9\-]+\.)+[a-z0-9\-]+(:[0-9]+)?(\/[a-z0-9\-._~%!$&'()*+,;=:@]+)*$/i;
        return regex.test(url) && url.length <= 512;
    };

    const handleInput = async (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox' && name === 'editBaseUrl') {
            setEditBaseUrl(checked);
            if (!checked) {
                // Reset base URL back to default when unchecking
                const defaultBase = PLATFORM_RTMP_URLS[formData?.platform] || '';
                setFormData((prev) => ({
                    ...prev,
                    custom_rtmp_base: '',
                    rtmp_url: defaultBase + (prev?.stream_key || ''),
                }));
            }
            return;
        }
        if (type === 'text' || type == 'select-one') {
            if (name === 'platform') {
                const platformUrl = PLATFORM_RTMP_URLS[value] || '';
                setEditBaseUrl(false);
                setFormData((prev) => ({
                    ...prev,
                    platform: value,
                    stream_key: '',
                    custom_rtmp_base: '',
                    rtmp_url: value === 'custom' ? '' : platformUrl,
                    hls_url: value === 'custom' ? (prev?.hls_url || '') : '',
                    watch_youtube_url: '',
                    source_type: value === 'custom' ? 'default' : 'social_media',
                }));
            } else if (name === 'custom_rtmp_base') {
                setFormData((prev) => ({
                    ...prev,
                    custom_rtmp_base: value,
                    rtmp_url: value + (prev?.stream_key || ''),
                }));
            } else if (name === 'stream_key') {
                const baseUrl = formData?.custom_rtmp_base || PLATFORM_RTMP_URLS[formData?.platform] || '';
                setFormData((prev) => ({
                    ...prev,
                    stream_key: value,
                    rtmp_url: baseUrl + value,
                }));
            } else {
                setFormData((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }
    }

    const formValidation = () => {
        let formIsValid = true;

        if (!formData?.title) {
            setFormDataError((prev) => ({ ...prev, title: "Please enter a title" }));
            combinedRef.current['title']?.focus();
            formIsValid = false;
        }

        if (!isCustomPlatform) {
            // Social media platform: validate stream key
            if (!formData?.stream_key) {
                setFormDataError((prev) => ({ ...prev, stream_key: "Please enter your stream key" }));
                combinedRef.current['stream_key']?.focus();
                formIsValid = false;
            }
        } else {
            // Custom: validate full RTMP URL
            if (!formData?.rtmp_url) {
                setFormDataError((prev) => ({ ...prev, rtmp_url: "RTMP URL cannot be empty." }));
                combinedRef.current['rtmp_url']?.focus();
                formIsValid = false;
            } else if (!isValidRtmpUrl(formData?.rtmp_url)) {
                setFormDataError((prev) => ({ ...prev, rtmp_url: "Please enter a valid RTMP URL (e.g., rtmp://example.com/app/stream)" }));
                combinedRef.current['rtmp_url']?.focus();
                formIsValid = false;
            } else if (formData?.rtmp_url.length > 512) {
                setFormDataError((prev) => ({ ...prev, rtmp_url: "RTMP URL must be less than 512 characters." }));
                combinedRef.current['rtmp_url']?.focus();
                formIsValid = false;
            }

            // HLS URL validation for custom
            if (!formData?.hls_url) {
                setFormDataError((prev) => ({ ...prev, hls_url: "HLS URL cannot be empty." }));
                combinedRef.current['hls_url']?.focus();
                formIsValid = false;
            } else if (!isValidHlsUrl(formData?.hls_url)) {
                setFormDataError((prev) => ({ ...prev, hls_url: "Please enter a valid HTTPS URL (e.g., https://example.com/stream.m3u8)" }));
                combinedRef.current['hls_url']?.focus();
                formIsValid = false;
            } else if (formData?.hls_url.length > 512) {
                setFormDataError((prev) => ({ ...prev, hls_url: "HLS URL must be less than 512 characters." }));
                combinedRef.current['hls_url']?.focus();
                formIsValid = false;
            }
        }

        return formIsValid;
    };

    const handleAll = () => {
        setSelectAll(!selectAll);
        setItemToDelete(selectAll ? [] : filteredData?.map((item) => item?.id));
    };
    const closeModal = () => {
        setModelClose((prev) => !prev);
        setItemToDelete([])
    };
    const handleFilter = (event) => {
        const searchTerm = event.target.value.toLowerCase();
        setFilter(searchTerm);

        if (searchTerm.trim() === '') {
            setFilteredData(apiData); // reset to full list
            return;
        }

        const filteredResults = apiData.filter((item) =>
            ["rtmp_url", "hls_url"].some((property) =>
                typeof item[property] === "string" &&
                item[property].toLowerCase().includes(searchTerm)
            ) ||
            (typeof item.sno === "number" &&
                item.sno.toString().includes(searchTerm))
        );

        setFilteredData(filteredResults);
    };
    const handleClear = () => {
        setFilter('');
        setFilteredData(apiData); // reset to full list
    };
    const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => (
        <div className="btn-group" role="group">
            <select
                className="form-select custom-page-select"
                value={currSizePerPage}
                onChange={(e) => onSizePerPageChange(e.target.value)}
            >
                {options.map((opt) => (
                    <option key={opt.page} value={opt.value}>
                        {opt.text}
                    </option>
                ))}
            </select>
        </div>
    );

    const options = {
        sizePerPageRenderer: sizePerPageRenderer,
        paginationSize: 4,
        sizePerPage: 10,
        nextPageText: 'Next',
        prePageText: 'Prev',
        firstPageText: <span><MdKeyboardDoubleArrowLeft /></span>,
        lastPageText: <span><MdKeyboardDoubleArrowRight /></span>,
        showTotal: true,
        alwaysShowAllBtns: true,
    };
    const selectRow = {
        mode: "checkbox",
        onSelect: (row, isSelect) => {
            if (row) {
                if (isSelect) {
                    setItemToDelete([...itemToDelete, row.id]);
                } else {
                    setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
                }
            }
        },
        style: { width: '50px' },
        selected: itemToDelete,
        selectionHeaderRenderer: ({ mode, checked }) => (
            <div>
                <input type="checkbox" checked={checked} onChange={handleAll} />
            </div>
        ),
    };

    const handleOpenModel = (value) => {
        setModelOpen(value === 1)
        if (!value) {
            setFormData({ platform: 'custom' })
            setEditBaseUrl(false)
        }
        setFormDataError({})
    }

    const handleSubmit = async () => {
        const formDataAdd = {};

        if (formValidation()) {
            if (formData?.id) {
                for (const key in formData) {
                    if (!["upload_on", "updatedAt", "createdAt"].includes(key)) {
                        formDataAdd[key] = formData[key]
                    }
                }
                setShowOverlay(true)
                await fetchRequest({
                    method: 'POST',
                    url: `${deleteUpdateApi}/${formData?.id}`,
                    params: {},
                    data: formDataAdd,
                })
                    .then(response => {
                        if (response?.status) {
                            toast.success(response?.message)
                            handleOpenModel(0)
                            setWithOutRefresh((prev) => !prev)
                        }
                    }).catch((error => {
                        toast.error(error?.response?.data?.message)
                    })).finally(() => {
                        setShowOverlay(false)
                    })

            }
            else {
                for (const key in formData) {
                    if (!["upload_on", "updatedAt", "createdAt"].includes(key)) {
                        formDataAdd[key] = formData[key]
                    }
                }
                setShowOverlay(true)
                await fetchRequest({
                    method: 'POST',
                    url: `${storeApi}`,
                    params: {},
                    data: formDataAdd,
                })
                    .then(response => {
                        if (response?.status) {
                            toast.success(response?.message)
                            handleOpenModel(0)
                            setWithOutRefresh((prev) => !prev)
                        }
                    }).catch((error => {
                        toast.error(error?.response?.data?.message)
                    })).finally(() => {
                        setShowOverlay(false)
                    })
            }

        }
    }


    const fetchEditData = async (id) => {
        await fetchRequest({
            method: 'GET',
            url: `${editApi}/${id}`,
            params: {},
            data: {},
        })
            .then(response => {
                if (response?.status) {
                    const result = response?.data
                    // Detect platform from existing rtmp_url
                    let detectedPlatform = 'custom';
                    let detectedStreamKey = '';
                    if (result?.rtmp_url) {
                        for (const [platform, baseUrl] of Object.entries(PLATFORM_RTMP_URLS)) {
                            if (result.rtmp_url.startsWith(baseUrl)) {
                                detectedPlatform = platform;
                                detectedStreamKey = result.rtmp_url.substring(baseUrl.length);
                                break;
                            }
                        }
                    }
                    setFormData({ ...result, platform: detectedPlatform, stream_key: detectedStreamKey })
                    handleOpenModel(1)
                }
            }).catch((error => {
                toast.error(error?.response?.data?.message)
            }))
    }

    const singlePeramanentDelete = (id) => {
        setModelClose(true);
        setItemToDelete([id]);
    }
    const [isDeleting, setIsDeleting] = useState(false);

    const handleConfirmDelete = async () => {
        setShowOverlay(true);
        await fetchRequest({
            method: 'DELETE',
            url: `${deleteUpdateApi}/${itemToDelete?.[0]}`,
            params: {},
            data: {},
        })
            .then(response => {
                const result = response;
                if (result?.status) {
                    setWithOutRefresh((prev) => !prev);
                    toast.success(result?.message);
                    setItemToDelete([])
                }
            })
            .catch(error => {
                toast.error(error?.response?.data?.message)
            }).finally(() => {
                setShowOverlay((prev) => !prev)
                closeModal()
            })
    };

    // Update your initial useEffect like this:
    useEffect(async () => {
        setLoading(true);
        try {
            const response = await fetchRequest({
                method: 'GET',
                url: `${indexApi}`,
                params: {},
                data: {},
            });

            if (response?.status) {
                // Check both possible response structures
                const result = response?.data?.["AllRTMP"] || response?.RTMP;

                if (result) {
                    const updatedList = await Promise.all(result?.map(async (item) => {
                        const UploadStatus = await findUploadName(item?.uploaded_by);
                        return { ...item, uploaded_by: UploadStatus };
                    }));

                    setApiData(updatedList);
                    setFilteredData(updatedList); // Make sure to set filteredData too
                }
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch RTMP URLs");
        } finally {
            setLoading(false);
        }
    }, [withOutRefresh]);

    useEffect(async () => {
        await fetchRequest({
            method: 'GET',
            url: `${labelApi}`,
            params: { source: 'site-settings' },
            data: {},
        })
            .then(response => {
                if (response?.status) {
                    const result = response?.label_management
                    setLabelDisplay(result)
                }
            }).catch((error => {
                toast.error(error?.response?.data?.message)
            }))
    }, [])
    const actionFormatter = (cell, row) => {
        return (
            <div className="editdropdown">
                <span className="editdropdown-button">
                    <span>
                        <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </span>
                </span>
                <div className="editdropdown-menu rtmpurleditbg p-2">
                    <button onClick={() => fetchEditData(row?.id)} className="theme-text-color theme-bg-color  w-100 d-block p-2">
                        <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                        <span className="ms-2">Edit</span>
                    </button>
                    <button onClick={() => singlePeramanentDelete(row?.id)} className="w-100 p-2 d-block theme-text-color theme-bg-color">
                        <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
                        <span className="ms-2">Delete</span>
                    </button>
                </div>
            </div>
        );
    };

    // Then use it in your columns definition:
    const columns = [
        {
            dataField: "sno",
            text: "S.No",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
            headerStyle: { width: '10%' },
            style: { width: '10%' },
        },
        {
            dataField: "title",
            text: "Title",
            formatter: (cell, row) => <MessageBox text={cell?.replaceAll("_", " ")} />,
            headerStyle: { width: '20%' },
            style: { width: '20%' },
        },
        {
            dataField: "rtmp_url",
            text: "RTMP URL",
            formatter: (cell, row) => <MessageBox text={cell?.replaceAll("_", " ")} />
        },
        {
            dataField: "hls_url",
            text: "HLS URL",
            formatter: (cell, row) => <MessageBox text={cell?.replaceAll("_", " ")} />,
            style: { width: '20%' },
        },
        {
            dataField: "actions",
            text: "Actions",
            formatter: actionFormatter,
        },
    ];

    return (

        <>
            <AdminBackNavigation backHistory path="/settings" text="Back" />
            {modelClose && (<AdminDeleteModal headingText={"Confirm Deletion"} message={"Are you sure you want to delete this RTMP URL?"} modelClose={modelClose} deleteClose={closeModal} deleteAction={handleConfirmDelete} buttonText={"custom"} actionText={"Delete"} buttonSubmitLoading={isDeleting} />)}


            <AdminSaveHeader heading={labelDisplay?.[11]?.title} saveText={labelDisplay?.[11]?.sub_title} saveMethod={() => handleOpenModel(1)} />

            <div class={`modal packageModel fade ${modelOpen && 'd-block show'}`} id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content theme-bg-color">
                        <div className="modal-header theme-border-bottom-secondary">
                            <MessageBox text={formData?.id ? labelDisplay?.[12]?.sub_title : labelDisplay?.[12]?.title} classname="modal-title theme-text-color admin-modal-title fw-bold" />
                            <button type="button" className='bg-transparent theme-text-color' onClick={() => handleOpenModel(0)} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
                        </div>
                        <div className="modal-body">
                            <MessageLabel text={`Platform`} className="mandatorySimple" />
                            <AdminCustomSelect name="platform" value={formData?.platform || 'custom'} options={PLATFORM_OPTIONS} ref={(el) => (combinedRef.current.platform = el)} onChange={handleInput} error={formDataError?.platform} />
                            {isCustomPlatform && (
                                <p className="theme-text-color mb-3" style={{ fontSize: '12px', opacity: 0.6, marginTop: '-8px' }}>Select a platform above or choose "Custom" to enter your own RTMP server details.</p>
                            )}

                            <MessageLabel text={`Title`} className="mandatorySimple" />
                            <AdminCustomInput type="text" name="title" value={formData?.title} ref={(el) => (combinedRef.current.title = el)} onChange={handleInput} placeHolder={"Ex: Streaming 1"} error={formDataError?.title} maxLength={512} />

                            {isCustomPlatform ? (
                                <>
                                    <MessageLabel text={labelDisplay?.[13]?.title || 'RTMP URL'} className="mandatorySimple" />
                                    <p className="theme-text-color mb-1" style={{ fontSize: '11px', opacity: 0.5, marginTop: '-8px' }}>Full RTMP URL including the stream key provided by your streaming server.</p>
                                    <AdminCustomInput type="text" name="rtmp_url" value={formData?.rtmp_url} ref={(el) => (combinedRef.current.rtmp_url = el)} onChange={handleInput} placeHolder={"rtmp://example.com/live/streamkey"} error={formDataError?.rtmp_url} maxLength={512} />

                                    <MessageLabel text={labelDisplay?.[14]?.title || 'HLS URL'} className="mandatorySimple" />
                                    <p className="theme-text-color mb-1" style={{ fontSize: '11px', opacity: 0.5, marginTop: '-8px' }}>The HLS playback URL where viewers can watch the live stream.</p>
                                    <AdminCustomInput type="text" name="hls_url" value={formData?.hls_url} ref={(el) => (combinedRef.current.hls_url = el)} onChange={handleInput} placeHolder={"https://example.com/livestream/streamkey.m3u8"} error={formDataError?.hls_url} maxLength={512} />
                                </>
                            ) : (
                                <>
                                    {/* RTMP Server URL label row */}
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <div>
                                            <MessageLabel text={`RTMP Server URL`} className="mandatorySimple mb-0" />
                                            <p className="theme-text-color mb-0" style={{ fontSize: '11px', opacity: 0.5 }}>The selected platform RTMP URL is already pre-defined, just enter the stream key only.</p>
                                        </div>
                                        <label className="d-flex align-items-center gap-1 theme-text-color text-nowrap" style={{ cursor: 'pointer', fontSize: '12px', opacity: 0.8 }}>
                                            <input
                                                type="checkbox"
                                                name="editBaseUrl"
                                                checked={editBaseUrl}
                                                onChange={handleInput}
                                                style={{ width: '14px', height: '14px', accentColor: '#5a8dee', cursor: 'pointer' }}
                                            />
                                            Edit URL
                                        </label>
                                    </div>
                                    <div className="d-flex align-items-center mb-1 rounded overflow-hidden custom-input-border" style={{ background: 'transparent' }}>
                                        {editBaseUrl ? (
                                            <input
                                                type="text"
                                                name="custom_rtmp_base"
                                                value={formData?.custom_rtmp_base || selectedPlatformUrl}
                                                onChange={handleInput}
                                                ref={(el) => (combinedRef.current.custom_rtmp_base = el)}
                                                placeholder="Enter custom RTMP base URL"
                                                maxLength={256}
                                                className="custom-input bg-transparent theme-text-color custom-placeholder border-0"
                                                style={{ outline: 'none', fontSize: '13px', minWidth: '180px', borderRight: '1px solid rgba(255,255,255,0.15)' }}
                                            />
                                        ) : (
                                            <span className="px-2 py-2 theme-text-color text-nowrap" style={{ opacity: 0.7, fontSize: '13px', borderRight: '1px solid rgba(255,255,255,0.15)', background: 'rgba(255,255,255,0.04)' }}>
                                                {selectedPlatformUrl}
                                            </span>
                                        )}
                                        <input
                                            type="text"
                                            name="stream_key"
                                            value={formData?.stream_key || ''}
                                            onChange={handleInput}
                                            ref={(el) => (combinedRef.current.stream_key = el)}
                                            placeholder="Paste your stream key here"
                                            maxLength={256}
                                            className="custom-input bg-transparent theme-text-color custom-placeholder w-100 border-0"
                                            style={{ outline: 'none' }}
                                        />
                                    </div>
                                    {formDataError?.stream_key && (
                                        <div className='d-flex align-items-center gap-1 mb-2'>
                                            <IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} />
                                            <MessageBox text={formDataError?.stream_key} classname='errorred d-block' />
                                        </div>
                                    )}

                                    {/* Composed URL preview */}
                                    {formData?.rtmp_url && (
                                        <div className="mb-3 p-2 rounded" style={{ background: 'rgba(255,255,255,0.03)', border: '1px dashed rgba(255,255,255,0.1)' }}>
                                            <MessageLabel text={`Final RTMP URL (auto-generated):`} />
                                            <AdminCustomInput isReadonly value={formData?.rtmp_url} />
                                        </div>
                                    )}

                                    <MessageLabel text={`Watch / Social Media URL`} />
                                    <p className="theme-text-color mb-1" style={{ fontSize: '11px', opacity: 0.5, marginTop: '-8px' }}>Optional. The public URL where viewers can watch the live stream.</p>
                                    <AdminCustomInput type="text" name="watch_youtube_url" value={formData?.watch_youtube_url} ref={(el) => (combinedRef.current.watch_youtube_url = el)} onChange={handleInput} placeHolder={PLATFORM_WATCH_URLS[formData?.platform] + 'your-id'} error={formDataError?.watch_youtube_url} maxLength={512} />
                                </>
                            )}
                        </div>
                        <div className="modal-footer border-0">
                            <button type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={() => handleOpenModel(0)} id="closeModal"><MessageBox text="Cancel" /> </button>
                            <AdminCustomButton className='px-3 py-1 m-0' saveMethod={() => handleSubmit()} saveText={formData?.id ? labelDisplay?.[15]?.title : labelDisplay?.[15]?.sub_title} loading={showOverlay}></AdminCustomButton>
                        </div>
                    </div>
                </div>
            </div>

            <div className="theme-bg-color p-4 rounded-3 bootstrapTable multi-delete-width">
                <div className="filterContainer" style={{ position: "relative" }}>
                    <input
                        type="text"
                        placeholder="Search the list"
                        className="filter form-control theme-text-color theme-border-secondary pe-5"
                        value={filter}
                        onChange={handleFilter}
                        maxLength={100}
                    />
                    {filter?.length > 0 && (
                        <button
                            type="button"
                            onClick={handleClear}
                            style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                background: "transparent",
                                border: "none",
                                padding: 0,
                                cursor: "pointer",
                            }}
                        >
                            <IoClose style={{ fontSize: "1.2rem", color: "#888" }} />
                        </button>
                    )}
                </div>

                <div style={{ position: 'relative' }}>
                    {loading && (<Defaultloadinggif className="heightOnLoader" />)}
                    <BootstrapTable keyField="id" data={filteredData} columns={columns} pagination={paginationFactory(options)} className="no-border-table theme-text-color" noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />} hover headerClasses="videoWidth" />
                </div>
            </div>

        </>
    );
}

export default Rtmpurl;
